/* eslint-disable react/prop-types */
/* react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react';
import swal from 'sweetalert';
import PropTypes from 'prop-types';
import { connect, useSelector, useDispatch } from 'react-redux';
import Title from '../../atoms/title/title';
import Select from '../../atoms/select/select';
import { mapDispatchToProps } from '../../../store/externalCalls/api/appApi';
import './pageTitle.scss';
import { storeStructure } from '../../../store/reducers';
import { createSession } from '../../../store/actions/sessionActions';
import { useParams, useLocation, useNavigate } from 'react-router-dom';

const PageTitle = (props) => {
  const {
    children,
    setAreaSession,
    history,
    match,
    disableArea,
    userNavigation,
    operatingSystem,
    disableConfig,
    configs,
    currentconfigId,
    onChangeMainHubConfig,
    showMainHubConfigSelect,
    mainHubConfigRef,
  } = props;

  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const session = useSelector((state) => state[storeStructure.Session]);
  let apps = [];
  const areas = useSelector((state) => {
    apps = state[storeStructure.APPS];
    if (session.appId !== undefined) {
      const currentApp = apps.find((app) => app.id === session.appId);
      if (currentApp !== undefined) {
        return currentApp.appConfigs.map((area) => ({ name: area.name, value: area.id }));
      }
    }
    return [];
  });

  const childRef = useRef();

  const changeArea = (areaId) => {
    const currentPath = location.pathname;
    const currentApp = apps.find((app) => app.id === session.appId);
    const appConfig = currentApp.appConfigs.find((area) => area.id === areaId);
    const basePath = currentPath.substring(0, currentPath.lastIndexOf('/'));
    const url = `${basePath}/${appConfig.name}`;
    dispatch(createSession({ appConfigSlug: appConfig.name }));
    setAreaSession(areaId);
    navigate(url, {
      state: {
        from: location.pathname,
      },
    });
  };

  const messageChangeArea = (areaId) => {
    if (session.isBlocking) {
      swal({
        title: 'Wait',
        text: 'You have unsaved changes, are you sure you want to leave?',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then((ok) => {
        if (ok) {
          dispatch(createSession({ isBlocking: false }));
          changeArea(areaId);
        } else {
          setAreaSession(session.areaId);
        }
      });
    } else {
      changeArea(areaId);
    }
  };

  const handlerOnChangeArea = (event) => {
    const areaId = event.target.value;
    messageChangeArea(areaId);
  };

  useEffect(() => {
    if (session?.areaId && childRef.current?.updateValue) {
      childRef.current.updateValue(session.areaId);
    }
  }, [session.areaId]);

  useEffect(() => {
    if (session.areaId !== params.areaId) {
      setAreaSession(params.areaId);
    }
  }, [params.areaId]);

  return (
    <div>
      <Title userNavigation={userNavigation}>{children}</Title>

      {showMainHubConfigSelect && configs?.length > 0 && (
        <>
          <div className="page-title__label">Config: </div>
          <Select
            id="mainhub-config-select"
            ref={mainHubConfigRef}
            options={configs}
            value={currentconfigId !== undefined ? currentconfigId : ''}
            className="page-title__select"
            onChange={onChangeMainHubConfig}
            disabled={disableConfig}
            writable
          />
        </>
      )}

      {!showMainHubConfigSelect && (
        <>
          <div className="page-title__label">Config: </div>
          <Select
            id="config-select"
            ref={childRef}
            options={areas}
            value={session.areaId !== undefined ? session.areaId : ''}
            className="page-title__select"
            onChange={handlerOnChangeArea}
            disabled={disableArea}
            writable
          />
        </>
      )}

      {operatingSystem && (
        <>
          <div className="page-title__label">Operating System</div>
          <div className="page-title__operatingSystem">{operatingSystem}</div>
        </>
      )}

      <hr />
    </div>
  );
};

PageTitle.propTypes = {
  children: PropTypes.string.isRequired,
  setAreaSession: PropTypes.func.isRequired,
  history: PropTypes.shape({}),
  match: PropTypes.shape({}).isRequired,
  disableArea: PropTypes.bool,
  disableConfig: PropTypes.bool,
  configs: PropTypes.arrayOf(PropTypes.shape({})),
  currentconfigId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChangeMainHubConfig: PropTypes.func,
  showMainHubConfigSelect: PropTypes.bool,
  mainHubConfigRef: PropTypes.shape({ current: PropTypes.any }),
};

PageTitle.defaultProps = {
  disableArea: false,
  disableConfig: false,
  configs: [],
  currentconfigId: '',
  onChangeMainHubConfig: undefined,
  showMainHubConfigSelect: false,
  mainHubConfigRef: undefined,
};

export default connect(null, mapDispatchToProps)(PageTitle);